import { likeSocialBundleWithRetry } from './functionsApi';

/**
 * Toggle like on a movie-activity bundle (movie_watched / movie_added).
 * Thin wrapper around the Cloud Function; bundle docs are lazy-created server-side.
 */
export async function toggleBundleLike(
  bundleId: string,
  actorUid: string,
  kind: 'movie_watched' | 'movie_added',
  action: 'like' | 'unlike'
): Promise<void> {
  await likeSocialBundleWithRetry(bundleId, actorUid, kind, action);
}
